const breakpoint = 1200;
let header = document.querySelector('header');

if(header) {
    const wrapperContent = header.querySelector('.wrapper').innerHTML;

    setMobileNav();

    function setMobileNav() {
        const button = document.querySelector(".menu-button");
        const navBar = document.querySelector("header .menu-content")
        const header = document.querySelector("header")
        const body = document.querySelector("body");
        const parent = document.querySelectorAll(".menu-item-has-children >a")
        const arrow = document.querySelectorAll(".menu-item-has-children >svg")

        button.onclick = function toggleMenu() {
            if (navBar.matches('.show')) {
                navBar.classList.remove("anim");
                setTimeout(function() {
                    navBar.classList.remove("show");
                }, 300);
                header.querySelector(".wrapper").classList.remove('anim');
                button.classList.remove("menu-close");
                header.classList.remove('show-menu');
                body.classList.remove('no-scroll');
            }
            else {
                navBar.classList.add("show");
                navBar.classList.add("anim");
                button.classList.add("menu-close");
                setTimeout(function() {
                    header.classList.add('show-menu');
                }, 300);
                header.querySelector(".wrapper").classList.add('anim');
                body.classList.add('no-scroll');

                // Hides dropdown when menu is hidden
                parent.forEach(function (ele) {
                    ele.classList.remove("show-ul");
                });
            }
        };


        //dropdown
        /**
         * check if parent has child with classname
         * on click add or remove class
        */
        parent.forEach(function (ele) {
            ele.addEventListener('click', function(e) {
                e.preventDefault();
                if (ele.parentNode.classList.contains('show-ul')) {
                    window.location = e.target.href;
                }
                else {
                    ele.parentNode.classList.add("show-ul");
                }
            });
        });
        arrow.forEach(function(ele) {
            ele.addEventListener('click', function(e) {
                e.preventDefault();
                if (ele.parentNode.classList.contains('show-ul')) {
                    ele.parentNode.classList.remove("show-ul");
                }
                else {
                    ele.parentNode.classList.add("show-ul");
                }
            });
        });
    }
}